import React from "react";
import { Badge as ChakraBadge, Box } from "@chakra-ui/react";
const backgroundColorByVariant = {
    success: "avocado.background",
    error: "danger.background",
    processing: "electric.background",
    warning: "warning.background",
    inactive: "base.background",
    draft: "white",
};
const textColorByVariant = {
    success: "avocado.base",
    error: "danger.base",
    processing: "electric.base",
    warning: "warning.base",
    inactive: "text.secondary",
    draft: "text.secondary",
};
const borderColorByVariant = {
    success: "avocado.border",
    error: "danger.border",
    processing: "electric.border",
    warning: "warning.border",
    inactive: "base.border",
    draft: "gray.300",
};
export function StatusBadge({ children, variant, progress, ...props }) {
    const hasProgress = variant === "processing" && typeof progress === "number";
    return (React.createElement(ChakraBadge, { variant: "status", background: hasProgress ? "white" : backgroundColorByVariant[variant], color: textColorByVariant[variant], borderColor: borderColorByVariant[variant], position: hasProgress ? "relative" : undefined, isolation: hasProgress ? "isolate" : undefined, overflow: hasProgress ? "hidden" : undefined, ...props },
        hasProgress && (React.createElement(Box, { position: "absolute", top: 0, left: "-100%", width: "100%", height: "100%", bg: backgroundColorByVariant[variant], transform: `translateX(${Math.max(0, Math.min(100, progress))}%)` })),
        hasProgress ? (React.createElement(Box, { as: "span", position: "relative" }, children)) : (children)));
}
